import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import SideBarContainer from 'Containers/SideBarContainer';
import TabPage from 'Components/TabPage';
import useTranslation from 'Hooks/useTranslation';
import useEmployeeProfile from './Hooks/useEmployeeProfile';
import resolveEmployeeIdentity from './identity';
import DevelopmentPlan from './Pages/DevelopmentPlan';
import Profile from './Pages/Profile';
import style from './style';

const { containerEmployee } = style;

/**
 * Perfil del empleado, con sus dos pestañas.
 *
 * Dos rutas, un componente: `/empleado/me` es mi perfil y `/empleado/:id` el de
 * otra persona. El identificador viaja por la URL y no por el estado de la
 * navegación, así que la pantalla sobrevive a un refresco.
 */
export default function EmployeeAssess() {
  const { t2 } = useTranslation('EmployeeAssess');
  const { id } = useParams<{ id?: string }>();
  const loggedUser = useSelector(userSelector);

  const { employeeId, isAdmin } = resolveEmployeeIdentity(id, loggedUser.id);

  const { profile, loading, refetch } = useEmployeeProfile(employeeId);

  const pages = [
    <Profile key="profile" profile={profile} loading={loading} isAdmin={isAdmin} onProfileChange={refetch} />,
    <DevelopmentPlan key="development-plan" profile={profile} isAdmin={isAdmin} />,
  ];

  return (
    <SideBarContainer>
      <div style={containerEmployee} className="col">
        <TabPage tabsTitle={[t2('Employee'), t2('DevelopmentPlan')]} pages={pages} />
      </div>
    </SideBarContainer>
  );
}
